import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertPrice, roundText } from '../../pages/PriceList/priceConversion.mjs';

// Warns when a price typed PER SALE UNIT does not divide evenly into the per-base-unit price the server stores
// (it rounds half-up at 12 decimals, so line totals may differ by a fraction). Same rule + wording as the Price List drawer.
// Renders nothing when exact, when there is no ratio, or when the price is not a number yet.
export default function UnitRoundNote({ price, ratio, sale, base, line }) {
  const { t } = useTranslation('sales');
  const c = ratio ? convertPrice({ typed: String(price ?? ''), unit: 'sale', ratio: String(ratio) }) : null;
  if (!c || !c.rounded) return null;
  const b = base || t('unitRound.baseFallback');
  return (
    <div className="warn" role="note" data-testid="unit-round-warn" style={{ marginTop: 6, fontSize: 11.5 }}>
      <span aria-hidden="true">ⓘ </span>
      {line != null && <b>{t('unitRound.line', { n: line })} </b>}
      {t('unitRound.warn', { sale: sale || t('unitRound.saleFallback'), base: b, price: String(price), ratio: String(ratio), other: roundText(c.other, 6) })}
    </div>
  );
}
